//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import throttle from '@/utils/throttle';
import * as orderListApi from '@/api/orderListApi.js';
import SelectSku from '../../../business/supplier/coupons/selectSku.vue';
export default {
  components: {
    SelectSku: SelectSku
  },
  data: function data() {
    return {
      meatLists: [{
        selectProduct: [],
        selectNum: null,
        comboName: ''
      }]
    };
  },
  props: {
    value: Array,
    initOption: Array
  },
  watch: {
    value: {
      handler: function handler() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        this.meatLists = val.length ? val : [{
          selectProduct: [],
          selectNum: null,
          comboName: ''
        }];
      },
      immediate: true,
      deep: true
    },
    initOption: {
      handler: function handler() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        this.meatLists = val.length ? val : [{
          selectProduct: [],
          selectNum: null,
          comboName: ''
        }];
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {},
  methods: {
    changeVal: function changeVal() {
      this.$emit("input", this.meatLists);
    },
    getMealVal: function getMealVal() {
      return this.meatLists;
    },
    removeMeat: function removeMeat(i) {
      this.meatLists.splice(i, 1);
    },
    handlerDelete: function handlerDelete(i, id) {
      if (this.meatLists[i] && this.meatLists[i].selectProduct && this.meatLists[i].selectProduct.length) {
        var removeIdx = this.meatLists[i].selectProduct.findIndex(function (item) {
          return item.id == id;
        });
        removeIdx != -1 && this.meatLists[i].selectProduct.splice(removeIdx, 1);
      }
      ;
    },
    modalPicTap: function modalPicTap(tit, i) {
      var _this = this;
      this.$modalUpload(function (img) {
        _this.mealImg = img[0].sattDir;
        _this.$set(_this.meatLists[i], 'image', img[0].sattDir);
      }, tit, 'system');
    },
    removeImg: function removeImg(i) {
      this.$set(this.meatLists[i], 'image', '');
    }
  }
};